import { Component, OnInit } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
//
// import { Achievement } from '../../../models/achievement.model';
// import { DataService } from "../../../services/data.service";

@Component({
  selector: 'app-achievement',
  templateUrl: './achievement.component.html',
  styleUrls: ['./achievement.component.css']
})
export class AchievementComponent implements OnInit {

  achievements: any;
  // constructor(private translate: TranslateService) { }

  constructor() {}
  ngOnInit() {
    // this.getAchievements();
  }

  // getAchievements() {
  //   this.translate.onLangChange.subscribe(() => {
  //     this.translate.get('home.achievements').subscribe( (response: any) => {
  //       this.achievements = response;
  //       // console.log(this.achievements);
  //     });
  //   });
  //
  // }

}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/achievement/achievement.component.ts